import { render } from "./ErrorInstanceLoad.vue?vue&type=template&id=354a8638&scoped=true"
const script = {}

import "./ErrorInstanceLoad.vue?vue&type=style&index=0&id=354a8638&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-354a8638"]])

export default __exports__